import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import DragAndDropList from 'hb-builder/components/common/DragAndDropList';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type {
  StripItemChildAttributes,
  StripsItemAttributes,
} from 'hb-react/backoffice/types/builder/itemAttributes/stripsItemAttributes';

import AddFrameButton from './AddFrameButton';
import ContentItem from './ContentItem';

const Content = ({
  item,
  onChange,
}: ComponentSettingsTab<StripsItemAttributes>) => {
  const stripsTemplateSlider = item
    ?.children?.[0] as DocumentItem<StripItemChildAttributes>;

  const getChildrenLength = () => stripsTemplateSlider?.children?.length || 0;

  return (
    <Wrapper>
      {/* @ts-expect-error not typed */}
      <DragAndDropList
        childrenComponent={ContentItem}
        componentName="Frame"
        item={stripsTemplateSlider}
        listButton={
          <AddFrameButton
            item={stripsTemplateSlider}
            getChildrenLength={getChildrenLength}
            type={item.type}
          />
        }
        onChange={onChange}
      />
    </Wrapper>
  );
};

export default Content;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
